"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Container = (0, _styledComponents2.default)(_Box2.default).withConfig({
  displayName: "Container",
  componentId: "n01zuu-0"
})([""]);

Container.defaultProps = {
  px: 6,
  py: 4,
  mx: "auto",
  maxWidth: 6
};

/** @component */
exports.default = Container;